// extracted by mini-css-extract-plugin
export default {"empty":"Result_empty__ncqtU","result":"Result_result__8FehH","result_icon":"Result_result_icon__Hln7T","result_text":"Result_result_text__y78IU","button":"Result_button__l1Hpl"};